// import livro from '../../imagens/livro.png'

export const livros = [
    {
      titulo: "Vue.js: Construa aplicações incríveis",
      preco: 29.9,
      autor: "Caio Incau",
      imagem: "https://caelum-online-public.s3.amazonaws.com/2628-js/Vue.js.png",
      alt: "Capa do livro de Front-end com Vue.js",
      quantidade: 50,
      categoria: "front-end"
    },
    {
      titulo: "PostgreSQL: Banco de dados para aplicações web modernas",
      preco: 89.9,
      autor: "Vinícius Carvalho",
      imagem: "https://caelum-online-public.s3.amazonaws.com/2628-js/postgres.png",
      alt: "Capa do livro de PostgreSQL",
      quantidade: 8,
      categoria: "dados"
    },
    {
      titulo: "Sass: Aprendendo pré-processadores CSS",
      preco: 79.9,
      autor: "Natan Souza",
      imagem: "https://caelum-online-public.s3.amazonaws.com/2628-js/Sass.png",
      alt: "Capa do livro de Front-end com Vue.js",
      quantidade: 11,
      categoria: "front-end"
    },
    {
      titulo: "HTML5 e CSS3: Domine a web do futuro",
      preco: 49.9,
      autor: "Lucas Mazza",
      imagem: "https://caelum-online-public.s3.amazonaws.com/2628-js/htmlcss.png",
      alt: "Capa do livro de HTML e CSS",
      quantidade: 0,
      categoria: "front-end"
    },
    {
      titulo: "Cangaceiro JavaScript: Uma aventura no sertão da programação",
      preco: 19.9,
      autor: "Flávio Almeida",
      imagem: "https://caelum-online-public.s3.amazonaws.com/2628-js/JavaScript.png",
      alt: "Capa do livro Cangaceiro JavaScript",
      quantidade: 42,
      categoria: "front-end"
    },
    {
      titulo: "Python: Escreva seus primeiros programas",
      preco: 9.9,
      autor: "Felipe Cruz",
      imagem: "https://caelum-online-public.s3.amazonaws.com/2628-js/python.png",
      alt: "Capa do livro de Python primeiros programas",
      quantidade: -2,
      categoria: "back-end"
    },
    {
      titulo: "Spring Boot: Acelere o desenvolvimento de microsserviços",
      preco: 29.9,
      autor: "Fernando Boaglio",
      imagem: "https://caelum-online-public.s3.amazonaws.com/2628-js/java.png",
      alt: "Capa do livro de Spring Boot",
      quantidade: 28,
      categoria: "back-end"
    },
    {
      titulo: "Django de A a Z: Crie aplicações web rápidas, seguras e escaláveis com Python",
      preco: 94.9,
      autor: "Tiago Silva",
      imagem: "https://caelum-online-public.s3.amazonaws.com/2628-js/django.png",
      alt: "Capa do livro de Django de A a Z",
      quantidade: 20,
      categoria: "back-end"
    },
    {
      titulo: "Guia Front-End: O caminho das pedras para ser um dev Front-End",
      preco: 139.9,
      autor: "Diego Eis",
      imagem: "https://caelum-online-public.s3.amazonaws.com/2628-js/guia.png",
      alt: "Capa do livro Guia Front-end",
      quantidade: 255,
      categoria: "front-end"
    },
    {
      titulo: "Pandas Python: Data Wrangling para Ciência de Dados",
      preco: 229.9,
      autor: "Eduardo Corrêa",
      imagem: "https://caelum-online-public.s3.amazonaws.com/2628-js/pandas.png",
      alt: "Capa do livro de Pandas Python",
      quantidade: 42,
      categoria: "dados"
    },
    {
      titulo: "Front-end com Vue.js: Da teoria à prática sem complicações",
      preco: 99.9,
      autor: "Flávio Almeida",
      imagem: "https://caelum-online-public.s3.amazonaws.com/2628-js/vue2.png",
      alt: "Capa do livro de Vue.js",
      quantidade: 0,
      categoria: "front-end"
    },
    {
      titulo: "ECMAScript 6: Entre de cabeça no futuro do JavaScript",
      preco: 11.9,
      autor: "Diego Martins de Pinho",
      imagem: "https://caelum-online-public.s3.amazonaws.com/2628-js/ecma.png",
      alt: "Capa do livro ECMAScript 6",
      quantidade: 0,
      categoria: "front-end"
    }
  ]